import Delete from "./delete";
import Manage from "./manage";

export const CommissionDistribution = { Manage, Delete };
